import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DataTable from "@client.components/DataTable";
import { useDispatch, useSelector } from "react-redux";
import {
  getTimeMeetingParticipantsAsync,
  makeTimeMeetingParticipants,
} from "./reducer";
import { getMeetingParticipantsColumns } from "./consts";
import { makeProfile } from "@client.pages/Login/reducer";
import "./TimeMeetingParticipantsDataTable.scss";
import { filterPropTypes } from "@client.components/Charts/utils";

const TimeMeetingParticipantsDataTable = ({ filter }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const profile = useSelector(makeProfile);
  const timeMeetingParticipants = useSelector(makeTimeMeetingParticipants);
  const [maximumHours, setMaximumHours] = useState(0);
  const [maximumParticapteCost, setMaximumParticapteCost] = useState(0);

  useEffect(() => {
    dispatch(
      getTimeMeetingParticipantsAsync({
        filter,
        isCostIndexPresentation: profile.isCostIndexPresentation,
      })
    ).then(({ payload }) => {
      let maxHours = 0;
      let maxParticipateCost = 0;

      if (payload) {
        payload.forEach((data) => {
          maxHours = Math.max(maxHours, data.hours);
          maxParticipateCost = Math.max(
            maxParticipateCost,
            data.meetingCostParticipate
          );
        });
      }

      setMaximumHours(maxHours);
      setMaximumParticapteCost(maxParticipateCost);
    });
  }, [dispatch, filter, profile]);

  return (
    <DataTable
      columns={getMeetingParticipantsColumns(
        t,
        maximumHours,
        maximumParticapteCost,
        profile.isCostIndexPresentation
      )}
      data={timeMeetingParticipants.data}
      isLoading={timeMeetingParticipants.load}
    />
  );
};

TimeMeetingParticipantsDataTable.propTypes = {
  filter: filterPropTypes,
};

export default TimeMeetingParticipantsDataTable;
